import old_pages from "./en-old-admin-pages";

const messages = {
  old_pages : old_pages,
  unnamed: '--unnamed--',
  id: 'ID',
  one: 'One',
  all: '--All--',
  pieces: 'pc.',
  placeholder_hm: 'HH:MM',
  placeholder_hms: 'HH:MM:SS',
  filter: 'Filters',
  filter_additional: 'Additional filters',
  filter_hide: 'Hide filter',
  filter_clear: 'Clear filters',
  group_settings: 'Group settings',
  search: 'Search',
  create: 'Create',
  add: 'Add',
  save: 'Save',
  back_to_list: 'Back to list',
  remove: 'Remove',
  apply: 'Apply',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  cancel: 'Cancel',
  confirm: 'OK',
  logout: 'Logout',
  sync_caches: 'Sync caches',
  sync_templates: 'Sync templates',
  resend: 'Resend',
  back: 'Back',
  display_charts: "Show graphics",
  attach: 'Attach',
  tableEmpty: 'Set search parameters <br> to get results',
  contentEmpty: 'There are no templates for the selected transport',
  browserNotSupport: 'This browser not supported',
  base_settings: 'Basic settings',
  additional_settings: 'Additional settings',
  cascading: 'Cascading',
  scheduler: 'Scheduler',
  smpp_settings: 'Settings SMPP account',
  processing_logic_settings : 'Processing logic settings',
  http_settings: 'Settings HTTP account',
  allowed_operators: 'Allowed service providers',
  new_originator: 'New originator',
  originator: 'Originator',
  originator_id: 'Originator',
  transport: 'Transport',
  service_provider: 'Service provider',
  partner: 'Client',
  description: 'Description',
  description_regex: 'Regex description',
  commentary: 'Comment',
  status: 'Status',
  login: 'Login',
  email: 'E-mail',
  password: 'Password',
  confirm_password: 'Confirm password',
  protocol: 'Protocol',
  name: 'Name',
  message_type: 'Message type',
  value: 'Value',
  system_setting: 'System setting variable',
  account: 'Account',
  account_id: 'Account',
  template: 'Template',
  rule: 'Rule',
  broker_account: 'Account',
  connection_type: 'Connection type',
  connection_duration: 'Connection duration',
  pool: 'Pool',
  text: 'Text',
  condition: 'Condition',
  transports: 'Channel',
  regex: 'Regular expression',
  regex_rule_delete: 'Delete regular expression',
  is_default: 'Default category',
  message_category: 'Message category',
  is_default_sms: 'Default category SMS',
  is_default_viber: 'Default category Viber',
  is_default_whatsapp: 'Default category WhatsApp',
  1:'Yes',
  0:'No',
  price:'Price',
  default_price: 'Default price',
  tarification: 'Tarification',
  tarification_by_category: 'Tarification by category',
  price_by_category: 'Shipping price by category',
  select_address: 'Set address for substitution:',
  select_pool: 'Select pool',
  account_name: 'Account name',
  account_login: 'Account login',
  push_statuses: 'Automatic receipt of delivery statuses',
  status_report: 'Report statuses',
  max_throughput: 'Max throughput',
  processing_rule: 'Processing rule',
  immediate_response_needed: 'Return submit_sm_resp immediately',
  additional_processing: 'Additional processing',
  for_all: 'All',
  final: 'Final',
  new_sender_address: 'New sender address',
  prepaid: 'Prepay',
  multisignature: 'Multisignature',
  template_only: 'Template only',
  moderation: 'Moderation',
  report_create_date: 'Creation date',
  report_finish_date: 'Finish date',
  choose_partner: 'Choose client',
  choose_transport: 'Choose transport',
  choose_template: 'Choose template',
  server: 'Server',
  connection_name: 'Connection name',
  status_duration: 'Status duration',
  messages_in_queue: 'Messages in queue',
  delivered_messages: 'Delivered messages',
  mt_per_min: 'Outbound messages',
  mo_per_min: 'Inbound messages',
  connection_status: 'Connection status',
  server_name: 'Server',
  current_status_duration: 'The duration of the connection in the current status',
  messages_in_queue_tooltip: 'Number of messages in the queue',
  delivered_messages_tooltip: 'Number of messages delivered',
  mt_per_min_tooltip: 'Number of outgoing messages per minute',
  mo_per_min_tooltip: 'Number of incoming messages per minute',
  newTemplate: 'New template',
  button_link: "Link to go",
  partner_user: 'Client account',
  sender: 'Sender',
  message: 'Message',
  priority: 'Priority',
  rules_order_by_priority: 'Rules order by priority',
  active: 'Activity',
  ttl: 'Message lifetime',
  max_retry_count: 'Maximum number of repeat calls',
  payload_type: 'Message type',
  dialing: 'Maximum dialing time',
  repeat_dtmf: 'DTMF key for repeat listening',
  max_repeat_count: 'Maximum number of repeat plays',
  redirect_number: 'Call forwarding number',
  redirect_dtmf: 'DTMF key for call forwarding',
  retry_timeout: 'Call retry interval',
  call_sms_flag: 'Send SMS on call',
  call_send_sms_end: 'At the end of the call',
  call_send_sms_dtmf: 'By pressing DTMF key',
  call_sms_template: 'SMS template',
  blacklist: 'Black list',
  sending_speed: 'Sending rate per second',
  message_length: 'Message length',
  statistic: 'Display text in statistics',
  use_cascading: 'Use cascading',
  channel: 'Channel',
  channel_id: 'Channel',
  multichannel_chanel: 'Channel',
  multichannel_template_name: 'Template',
  multichannel_timeout: 'Timeout',
  tooltip_timeout:'Time in format HH:MM:SS, after which the sending will be carried out via an alternative channel',
  send_date: 'Send date',
  send_time: 'Send time',
  allowed_days: 'Days of sending',
  send_evenly: 'Even distribution',
  translit: 'Transliteration',
  char_entered: 'Characters entered',
  variables: 'Variables',
  total: 'Total',
  originator_restrictions: 'Allowed originators',
  date: 'Date',
  date_from: 'Date from',
  date_to: 'Date to',
  event_date: 'Date',
  group_by: 'Group by ',
  group_by_optionally: 'Additionally group by ',
  sent_date_from: 'Sent date from',
  sent_date_to: 'Sent date to',
  deliver_date_from: 'Delivery date from',
  deliver_date_to: 'Delivery date to',
  defer_date: 'Defer date',
  sent_date: 'Sent date',
  recipient: 'Recipient',
  recipient_country: 'Country',
  country: 'Country',
  recipient_region: 'Region',
  receiver: 'Recipient',
  message_parts: 'Number of message parts',
  error_code: 'Error code',
  error_description: 'Error description',
  template_id: 'Template ID',
  bulk_id: 'Bulk ID',
  operator: 'Operator',
  mcc: 'MCC',
  mnc: 'MNC',
  broker_account_login: 'Broker account',
  partner_name: 'Client name',
  partner_login: 'Client login',
  smpp_message_id: 'SMPP ID',
  smpp_connection: 'SMPP-connect',
  external_id: 'External ID',
  create_date: 'Create date',
  postponed_date: 'Postponed date',
  delivery_date: 'Delivery date',
  source_type: 'Source type',
  parent_message_id: 'Parent message ID',
  parent_message_channel: 'Parent message channel',
  detail: 'Details',
  price_for_partner: 'Client price',
  price_from_provider: 'Provider price',
  ext_id1: 'Ext_ID 1',
  ext_id2: 'Ext_ID 2',
  ext_id3: 'Ext_ID 3',
  ext_id4: 'Ext_ID 4',
  ext_id5: 'Ext_ID 5',
  service_number: 'Number',
  service_no: 'Service number',
  originator_operator: 'Operator',
  originator_country: 'Country',
  message_segments: 'Number of SMS message segments',
  transmitted: 'Transmitted',
  delivered: 'Delivered',
  not_delivered: 'Not delivered',
  expired: 'Expired',
  failed: 'Failed',
  error: 'Error',
  rejected: 'Rejected',
  deferred: 'Deferred',
  inAll: 'All',
  income: 'Income',
  rate: 'Expense',
  transmitted_parts: 'Transmitted (parts)',
  delivered_parts: 'Delivered (parts)',
  not_delivered_parts: 'Not  (parts)доставлено',
  expired_parts: 'Expired (parts)',
  failed_parts: 'Failed (parts)',
  error_parts: 'Error (parts)',
  rejected_parts: 'Rejected (parts)',
  deferred_parts: 'Deferred (parts)',
  total_parts: 'Total (parts)',
  transmitted_tooltip: 'Messages have been sent to the service provider, but the delivery status has not yet been received',
  delivered_tooltip: 'Messages were delivered to the subscriber',
  not_delivered_tooltip: 'Messages were not delivered to the subscriber. Final status',
  expired_tooltip: "Messages have been sent to the service provider, their lifetime expired in the provider's queue",
  failed_tooltip: 'An error occurred while trying to send a message',
  rejected_tooltip: 'Messages were rejected by the platform',
  deferred_tooltip: 'Messages will be sent later',
  total_tooltip: 'Total number of messages',
  partner_price_tooltip: 'Client price',
  provider_price_tooltip: 'Service provider price',
  start_date: 'Start date',
  end_date: 'End date',
  start_date_from: 'Start date from',
  start_date_to: 'Start date to',
  end_date_from: 'Delivery date from',
  end_date_to: 'Delivery date to',
  content: 'Content',
  call_duration: 'Call duration',
  module: 'Module',
  provider_message_id: "Operator ID",
  provider_protocol: "Operator protocol",
  ring_duration: "Ring duration",
  incoming_number: 'Incoming number',
  finished: 'Finished',
  not_answered: 'Not answered',
  buffered: 'Buffered',
  duration: 'Duration',
  partner_price: 'Partner price',
  provider_price: 'Service provider price',
  subject: 'Subject',
  message_text: 'Message text',
  show_message_text: 'Show message text',
  message_text_empty: 'Message text empty',
  empty: 'Empty',
  read_date: 'Read date',
  read: 'Read',
  read_tooltip: 'Messages have been read',
  price_for_provider: 'Service provider price',
  email_from: 'Email from',
  attaches: 'Attachments',
  application: 'Application',
  platform: 'Platform',
  device: 'Device',
  title: 'Title',
  content_load_date: 'Content load date',
  choose_application: 'Choose application',
  settings_fcm: 'FCM settings',
  settings_apns: 'APNS setting',
  settings_hms: 'HMS settings',
  settings_xiaomi: 'Xiaomi settings',
  settings_dp: 'Direct PUSH settings',
  settings_dp2: 'Direct PUSH 2 settings',
  settings_rustore: 'RuStore settings',
  project_id: 'Project ID',
  service_token: 'Service token',
  type: 'Type',
  devices_policy: 'Devices policy',
  check_sign: 'Verify signature for requests to MobileApi',
  connection_count: 'Connections count',
  android_count: 'Android',
  ios_count: 'iOS',
  total_count: 'Total',
  subscribed: 'Subscribed',
  unsubscribed: 'Unsubscribed',
  pic_link: 'Picture link',
  button_name: 'Button name',
  link_button: 'Button link',
  postponed_message_date: 'Postponed date',
  expire_date: 'Expire date',
  viber_message_id: 'Viber ID',
  image: 'Image',
  image_link: 'Image link',
  upload_file_description: 'Drag and drop the file onto the page or click the upload button',
  btn_link: 'Button link',
  read_subscriber_tooltip: 'Messages have been read by the subscriber',
  push_message_id: 'Push ID',
  whatsapp_message_id: 'WhatsApp ID',
  first_name: 'Name',
  mail: 'Email',
  timezone: 'Time zone',
  show_messages_text: 'Display message texts',
  is_check_pass: 'Change password at next login',
  show_finance_info: 'Show financial information',
  role: 'Role',
  role_use: 'Use the role',
  role_settings: 'Role settings',
  access_settings: 'Access settings',
  without_role: '--Without role--',
  topic: 'Topic',
  from_whom: 'From whom',
  user_pages: 'Pages',
  allow: 'Allow',
  deny: 'Deny',
  on_moderation: 'Take for moderation',
  edit_date: 'Edit date',
  select_reason: 'Select reason',
  recipients_count: 'Recipients count',
  action_date: 'Date',
  action_user: 'User',
  action_page: 'Page',
  action_source: 'User interface',
  object_type: 'Object type',
  object_name: 'Object name',
  action: 'Action',
  ip_address: 'User IP-address',
  additional_info: 'Additional Information',
  action_source_admin: 'Admin Console',
  action_source_lk: 'Client Console',
  system_actions: 'Boolean actions',
  success: 'Success',
  select_action_source: 'Select user interface',
  detail_info: 'Message info',
  detail_incoming: 'Detailed statistic of incoming',
  group: 'Group statistic',
  group_incoming: 'Group statistic of incoming',
  originators: 'Originators',
  partners: 'Clients',
  partner_id: 'Client',
  quantity: 'Quantity',
  service_providers: 'Service providers',
  templates: 'Templates',
  templates_new: 'Create template',
  templates_edit: 'Edit template',
  timeout: 'Timeout',
  message_limit: 'Number of messages',
  regexp: 'Regular expression',
  access: 'Access',
  service_providers_empty: 'No service providers',
  not_selected_service_providers: 'No service provider selected',
  priority_more_zero: 'Priority must be greater than 0',
  choose_client: 'Choose a client',
  choose_role: 'Choose a role',
  sections:'Sections',
  amount: 'Amount',
  source: 'Source',
  balance: 'Balance',
  overdraft: 'Shutdown threshold',
  helper_overdraft:'When this threshold is reached, the client will send messages via any of the connected channels',
  setup_overdraft: 'Set up  the shutdown threshold',
  top_up_balance: 'Top up balance',
  top_up: 'Top up',
  displayed_balances_version: 'Balances as of the current date are displayed ',
  administrator: 'Administrator',
  balance_completed: 'Balance topped up successfully',
  resend_message: 'Resend message',
  number_subscriptions: 'Number of subscriptions',
  number_subscriptions_day: 'Number of subscriptions per day',
  number_contacts:'Number of contacts',
  delete_contact: 'Delete contact(s)',
  separator: 'Separator',
  file:'File',
  addresser:'Originator',
  user_parameters: 'User parameters"',
  custom_message_id: 'Custom ID',
  emailAttachedFilesSizeLimit: 'Could not attach the file {filename} - the size of the attachment files exceeds 25 megabytes',
  processed: 'Processed',
  use_proxy: 'Use proxy',
  hostname: 'Hostname',
  port: 'Port',
  access_denied: "Page access denied",
  ad_group_name: 'Active Directory User Group',
  mn_service: "MN service",
  mn_template: "Mail Notify template",
  mn_routes: 'List of social networks to send',
  vk_message: 'Message for VK',
  ok_message: 'Message for OK',
  os: 'OS',
  owner: 'Owner',
  cloud: 'Cloud',
  operating_system: 'Operating system',
  app_version: 'Application version',
  os_version: 'OS version',
  sdk_version: 'SDK version',
  check_contacts_uniqueness: 'Check contacts for uniqueness',
  check_duplicates_policy: 'Uniqueness check options',
  check_with_msisdn: 'Check with msisdn',
  check_with_email: 'Check with email',
  check_with_msisdn_email: 'Check with msisdn and email',
  file_only: 'File only',
  file_and_group: 'File and group',
  page_size: 'Page size',
  page_number: 'Page number',
  order_by: 'Order by',
  order_direction: 'Order direction',
  message_direction: 'Message direction',
  message_id: 'Message ID',
  import_success: 'Import completed successfully',
  import_error: 'Import error',
  invalid_file: 'Invalid file',
  added_zones_count: 'Tariff zones added',
  edited_zones_count: 'Tariff zones changed',
  failed_zones_count: 'No tariff zones added',
  black_list: 'Black list',
  general: 'General',
  number: 'Number',
  widget_type: 'Widget type',
  reason: 'Reason',
  reset_password: 'Reset password',
  old_role_id: "Previous role",
  new_role_id: "New role",
  cancel_cascading: "Cancel Cascading by Status",
  tooltip_cancel_cascading: "When enabled, sending a message via an alternative channel will be canceled if one of the statuses marked below in the «Cancellation Statuses» field was received for the message",
  cancellation_status: "Cancellation Statuses",
  masking: "Masking",
  masking_method: "Masking Method",
  do_not_mask: "Do Not Mask",
  mask_all_text: "Entire Text",
  mask_variables_only: "Variables Only",
  mask: "Mask",
  masked_variables_from_text: "Masked Variables from Text",
  default_masked_variables: "By default, the following variables are masked: {variables}.",
  delivery_type: "Delivery type",
  send_web_push: "Sending WEB PUSH",
  settings_seng_web_push: "Settings for sending WEB PUSH",
  public_key: "Public key",
  private_key: "Private key",
  sender_signature: "Sender's signature",
  applications: 'Applications',
  app_groups: 'App Groups',
  app_by_date: 'Selection by Creation Date',
  app_by_date_tooltip: 'Select an application by its creation date. If All is selected, notifications will be sent to all\n' +
      '                  selected applications. If Latest Created is selected, notifications will only be sent to the latest created application.\n' +
      '                  Only applications that the recipient is subscribed to are included in the selection.',
  group_selection_rule: 'Group Selection Rule',
  group_selection_rule_tooltip: 'App group selection rule. If All is selected, all groups will be chosen for sending.\n' +
      '                  If By Priority is selected, only the highest-priority group will be chosen for sending.\n' +
      '                  Only groups with at least one application the recipient is subscribed to are included in the selection.',
  app_selection_rule: 'App Selection Rule',
  app_selection_rule_tooltip: 'App selection rule. If All is selected, all apps in the group will be selected for sending.\n' +
      '                  If By Priority is selected, only the highest-priority app in the group will be chosen.\n' +
      '                  If "Latest Created" is selected, the latest created app in the group will be chosen for sending.\n' +
      '                  Only applications that the recipient is subscribed to are included in the selection.',
  sublist_settings: 'Subscription Settings',
  sublist_app_by_date_tooltip: 'Subscription selection by creation date. If All is selected, notifications will be sent to all app subscriptions.\n' +
      '                  If Latest Created is selected, notifications will only be sent to the latest created app subscription.',
  push_application: 'Push-application',
  push_applications_groups_priority: 'Push applications groups priority',
  host: 'Host',
  proxy_settings: 'Proxy server',
  file_ivr_menu: 'File IVR-menu',
  incoming_calls: "Incoming calls",
  position: "Position",
  blacklist_channel: "{field} blacklist",
  blacklist_channel_global: "Global blacklist",
  update: 'Update',
  enter_name: 'Enter name',
  clone: 'Clone',
  clone_template: 'Cloning the template',
  clone_description: 'After clicking on "Proceed", the page for editing the new template will open',
  proceed: "Proceed",
  preview: "Preview",
  pc_version: 'PC version',
  mobile_version: 'Smartphone version',
  display: "Display",
  publicity: "Publicity",
  publicity_tooltip: "Configuring access of this template to other clients of the system. The Public value means it is accessible to all clients of the system. The Non-public value means that only the specified client will have access to the template.",
  only_transferred: "Only those actually transferred",
  only_transferred_tooltip: "Select the display mode for message statuses: all statuses for all messages or only statuses of those sent to the cloud service. This switch will help you track the percentage of notifications delivered.",
  custom_data: "Custom data",
  special_unsubscribe_rule: 'Special unsubscribe rule',
  unsubscribe_links_regex: 'Regular expression to find unsubscribe links',
  unsubscribe_rule: 'Email-body link unsubscribe rule',
  subscribe_links_regex: 'Regular expression to find subscribe links',
  subscribe_rule: 'Email-body link subscribe rule',
  proxy_links_regex: 'Regular expression for searching links for proxying',
  events: 'Events',
  events_count: 'Events count',
  eventDate: 'Event date',
  event_type: 'Event type',
  event_report: 'Report events',
  link: 'Link',
  delivery_method: 'Delivery type',
  openings: 'Openings',
  following_links: 'Followings links',
  unsubscribings: 'Unsubscribings',
  subscribings: 'Subscribings',
  attr_subscriber:"Subscriber attribute",
  client_id: "Client ID",
  token: "Token",
  attr_device: "Device attribute",
  device_id: "Device ID",
  vendor: "Vendor",
  push_enabled: "Push enabled",
  additional_params: "Additional template params",
  key: 'Key',
  value_settings: "Value Settings",
  min_length: "Min Length",
  max_length: "Max Length",
  min_value: "Min Value",
  max_value: "Max Value",
  limitations: "Restrictions",
  ext_event_profile_id: "Event profile ID",
  ext_client_profile_id: "Client profile ID",
  filter_by_client: "Filters by client",
  filter_by_event: "Filters by event",
  ext_campaign_id: "External campaign ID",
  ext_request_id: "External request ID",
  ext_add_param: 'Additional parameter {number}',
  client_attribute: 'Client attribute',
  event_attribute: 'Event attribute',
  ext_add_params: 'Information about additional fields',
  processed_date: 'Processed date',
  server_info: 'Server info',
  ext_client_profile_data: 'Client profile information from an external system',
  ext_event_profile_data: 'Event profile information from an external system',
  new: "New",
  new_tooltip: "Events were successfully received and are ready for processing",
  processed_tooltip: "Events have been successfully processed",
  error_tooltip: "An error occurred while processing the events",
  originators_count: 'Number of addresses in pool',
  ivr_menus: 'IVR-menu',
  path: "Path",

  auth: {
    title: 'Admin Console',
    description: 'Log in',
    changing_title: 'According to the security policy, you need to change your password',
    button: 'Log in',
    back: 'To the login page',
    change_password: 'Change password',
    language: 'Language',
    email: 'Email',
    password: 'Password',
    new_password: 'New password',
    confirm_new_password: 'Confirm new password',
    login: 'Email / Login AD',
  },

  system_settings: {
    ADMIN_LOGS_STORAGE_TIME: 'Log storage period in days',
    BROKER_MESSAGES_STORAGE_TIME: 'Statistics retention period for BROKER_MESSAGES',
    CALL_ALLOWED_OP: 'Sending calls through operators. Possible values: ALL - through any; Operator1; Operator2 - through allowed, where Operator1 and Operator2 are the names of service providers',
    CALL_ROUTING: 'Call routing type. Possible values: MCC/MNC - according to MCC/MNC; MSISDN - by MSISDN prefix',
    CALL_STORAGE_TIME: 'Statistics retention period for CALL',
    CALL_TARIFF: 'Call billing type. Possible values: SEC - per second; MIN - per minute',
    DEFAULT_TZ: 'Default timezone. Possible values are from -11 to 12',
    EMAIL_STORAGE_TIME: 'EMAIL statistics storage period',
    LOG_ACTIONS: 'Logged actions. Possible values: 1 - reading; 2 - creation; 3 - editing; 4 - removal; 5 - sending;. Values are specified separated by commas - 1,2,3,4,5',
    MAX_AUTH_ATTEMPTS: 'The maximum number of failed user authorizations in a row. If the maximum number is exceeded, the user account is deactivated. If = 0, no restrictions',
    PASSWORDS_STORAGE_QUANTITY: 'The number of saved old passwords for system users and personal account. If = 0, old passwords are not saved',
    PASSWORDS_VALIDITY_PERIOD: 'The maximum lifetime of passwords for users of the system and personal account in days. If = 0, no restrictions',
    PUSH_STORAGE_TIME: 'Statistics retention period for PUSH',
    REPORTS_COUNT: 'Number of simultaneous report uploads in the system',
    SMS_ALLOWED_OP: 'Sending SMS through operators. Possible values: ALL - through any; Operator1; Operator2 - through allowed, where Operator1 and Operator2 are the names of service providers',
    SMS_BLOCK_PRIORITY: 'List of priorities that require SMS blocking. Possible values: 2 - Low; 4 - Medium; 6 - High; 8 - Realtime; Values are specified separated by commas - 2,4,6,8',
    SMS_ROUTING: 'SMS routing type. Possible values: MCC/MNC - by MCC/MNC; MSISDN - by prefix MSISDN',
    SMS_STORAGE_TIME: 'SMS statistics storage period',
    SMS_TARIFF: 'SMS billing type. Possible values: D - for delivery; SENDING - for sending',
    STAT_DATE_OFFSET: 'Maximum number of days to display in reports',
    UNDELIVERED_SMS_COUNT: 'The number of consecutive undelivered SMS to the subscriber to block further sending. Possible values: 0 - blocking disabled; N - blocking when N consecutive undelivered SMS, where N is a positive integer greater than zero',
    UNDELIVERED_SMS_PERIOD: 'The minimum number of days for which the subscriber must have UNDELIVERED_SMS_COUNT of undelivered SMS to block. Possible values: 0 - minimum period is not set; N - the minimum period equal to N days, where N is a positive integer greater than zero',
    VIBER_STORAGE_TIME: 'Statistics retention period for VIBER',
    IVR_PREFIX_URL: 'URL Prefix for getting audio file by WCS',
    MAX_WIDGETS_NUM: 'Maximum number of widgets to display',
    USERS_TEMPORARY_BLOCKING_TIMEOUT: 'Temporary blocking period for Admin Interface and Dashboard accounts (in minutes)',
    USERS_SYSTEM_BLOCKING_TIMEOUT: 'The period of inactivity of the accounts of the Administrator Interface and the Personal Account (in days), after which the automatic blocking occurs',
    PASSWORDS_DIFFERENCE_SYMBOLS_NUMBER: 'Minimum number of characters by which a new password must differ from the last one',
    PASSWORDS_MINIMAL_LENGTH: 'Minimum password length',
    PUSH_DEFERRED_DELAY_BEFORE_ALL: 'The delay for all platforms before sending the delayed push to the device as a percentage of the difference between the scheduled time of sending and the time of mailing creation',
    PUSH_DEFERRED_DELAY_BEFORE_ANDROID: 'The delay for the Android platform before sending a delayed push to the device as a percentage of the difference between the scheduled time of sending and the time of mailing creation',
    PUSH_DEFERRED_DELAY_BEFORE_IOS: 'The delay for the iOS platform before sending a delayed push to the device as a percentage of the difference between the scheduled time of sending and the time of mailing creation',
    PUSH_DEFERRED_DELAY_BEFORE_HUAWEI: 'The delay for the Huawei platform before sending a delayed push to the device as a percentage of the difference between the scheduled time of sending and the time of mailing creation',
    PUSH_DEFERRED_DELAY_BEFORE_XIAOMI: 'The delay for the Xiaomi platform before sending a delayed push to the device as a percentage of the difference between the scheduled time of sending and the time of mailing creation',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_ALL: 'Minimum delay for all platforms before sending the delayed push to the device in hours',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_ANDROID: 'Minimum delay for the Android platform before sending a delayed push to the device in hours',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_IOS: 'Minimum delay for the iOS platform before sending a delayed push to the device in hours',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_HUAWEI: 'Minimum delay for the Huawei platform before sending a delayed push to the device in hours',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_XIAOMI: 'Minimum delay for the Xiaomi platform before sending a delayed push to the device in hours',
    AUTHORIZATION_TYPE: 'Authorization type. Possible values: 1 - by the system login/password; 2 - by the Active Directory login/password; 3 - both methods',
    ACTIVE_DIRECTORY_URL: 'Active Directory connection string',
    ACTIVE_DIRECTORY_DOMAIN: 'Active Directory domain name',
    ACTIVE_DIRECTORY_DEFAULT_PARTNER_ID: 'Client identifier, whose access rights are granted by default to Client Console users, who authenticate via Active Directory',
    ACTIVE_DIRECTORY_REQUEST_TIMEOUT: 'Timeout (in seconds) for waiting for a response from the Active Directory server',
    ATTACHMENT_SIZE_LIMIT_EMAIL: 'Email attachment size limit',
    DEFAULT_PAGE_SIZE: 'Default message package size',
    MAX_RESEND_MESSAGES_NUM: 'Maximum number of forwarded messages',
    DISTRIBUTION_MODERATION_POLICY: 'Distribution moderation policy',
    CRM_ALLOWED_TEMPLATES_MESSAGE_TYPES: 'Allowed message types for templates to send to CRM',
    EMAIL_VERIFY_TEMPLATE_ID: 'ID of the template for sending the email confirmation code',
    SELFREGISTRATION_ACTIVATION: 'Activation flag for self-registration of the user interface',
    IMPORT_FILE_ROWS_LIMIT: 'Maximum number of records in imported file',
    BLACKLIST_DUPLICATE_POLICY: 'The policy of checking duplicates in the general blacklist. Possible values: 0 – parameters are not checked, 1 – only msisdn is checked, 2 – only email is checked, 3 – msisdn and email are checked',
    PASSWORD_RESET_ATTEMPTS_TIME_LIMIT: 'Time limit between attempts to reset the password of the user of the personal account. Set in minutes.',
    USE_CAPTCHA_FOR_PASSWORD_RESET: 'Flag for using captcha when resetting a password',
    CHANGE_PASSWORD_TEMPLATE_ID: 'ID of the template for sending the password reset link',
    MASKING_SYSTEM_VARIABLES: 'System variables for masking separated by commas',
    MASKING_POLICY: 'Masking policy. Possible values: 0 – all characters of masked variables are replaced with the value MASKING_SYMBOL, N (integer greater than 1) – all masked variables are replaced with N characters MASKING_SYMBOL',
    MASKING_SYMBOL: 'Masking symbol',
    EXPORT_REPORTS_STORAGE_TIME: 'Storage time of export reports (in days)',
    WHITELIST_DUPLICATE_POLICY: 'The policy of checking duplicates in the whitelist. Possible values: 0 – parameters are not checked, 1 – only msisdn is checked, 2 – only email is checked, 3 – msisdn and email are checked'
  },

  errors: {
    internal: 'Internal server error.',
    validation: 'Validation error.',
    violation: 'A record with identical parameter(s) already exists.',
    rule_must_be_unique: "The rules must not be repeated",
    invalid_length_field: '{field} must be 2 or 3 characters long',
    category_not_deleted:'It is impossible to delete a category.<br>It is impossible to automatically reconfigure tariff zones (tariffs).',
    dependent_transport:'Unable to deactivate transport because there are dependent entries.',
    not_found: 'Record not found.',
    invalid_credentials: 'It is impossible to log in.<br>Incorrect login / password.',
    user_locked: 'It is impossible to log in.<br>Your account is blocked.',
    incorrect_password: 'It is not possible to change the password.<br>This password has already been used.',
    mandatory_parameters:'Missing mandatory parameters or request syntax error.',
    client_denied_transport: 'It is impossible to activate account.<br>The selected channel is not allowed to the client.',
    client_locked: 'It is impossible to activate the account.<br>The client is blocked.',
    unauthorized: 'Access error.',
    main_reserve_filled: 'Main and Reserve modules are filled.',
    overlapping_conditions: 'It is impossible to save the rule.<br>Contains an intersection with existing rules.',
    max_widgets_num: 'It is impossible to add a new widget.<br>The widget limit has been exceeded.',
    password_difference_symbols: 'It is not possible to change the password.<br>The new password must differ from the previous one by at least',
    password_length: 'It is not possible to change the password.<br>The new password must have a length of at least',
    user_temporary_locked: 'It is impossible to log in.<br>Your account is blocked due to multiple incorrect login/password.',
    user_locked_by_system: 'It is impossible to log in.<br>Your account is blocked because You have not logged in for more than {0}.',
    users_exists_with_this_role: 'It is impossible to delete the role.<br>There is a user with this role.',
    duplicate_value_message_role: 'It is impossible to save the role.<br>The role of a user with this name already exists.',
    transport_not_allowed_for_client: 'Transport is not allowed for this client.',
    transport_cascading_not_allowed_for_client: 'The cascading transport is not allowed for this client.',
    active_directory_not_set: 'It is impossible to log in.<br>Active Directory connection settings are not set.',
    user_already_in_system: 'It is impossible to log in.<br>A user with this login already exists in the System.',
    unable_remove_default_user: 'It is impossible to delete the default user.',
    unable_change_default_user: 'It is impossible to change default user settings.',
    have_not_permission_for_this_user: 'It is impossible to edit the user.<br>There are not enough rights to edit this user.',
    unable_remove_default_role: 'It is impossible to delete the default role.',
    unable_change_default_role: 'It is impossible to change the default role.',
    no_data_to_export: 'Unable to export.<br>No data to export.',
    no_data_to_show: 'No data to show.',
    duplicate_additional_rule: 'Unable to save custom rule.<br>A custom rule with these settings already exists.',
    have_users_with_this_role: 'Functions of users with this role, before deleting the role, you must change their role to a new one.',
    unable_to_reset_category_transport: 'Unable to change category\'s transports list because tariffs of the following providers have no default price: ',
    tariff_zones_of_the_group_not_empty: 'Operation error, first you need to delete the tariff zones of the group',
    template_with_used_active_bulk: 'This template is used for active bulk',
    active_directory_server_unavaible: 'It is impossible to log in. The Active Directory server is unavailable',
    unable_set_ad_group: 'The Active Directory user group cannot be specified.<br>This group is already involved for another role',
    server_unavailable: 'The request could not be completed. Application server unavailable',
    email_resend_failed_whithout_template: 'This message was originally sent without a template, so it cannot be sent with attachments (if they already existed). Do you want to continue?',
    email_resend_failed_whithout_text: 'Unable to resend message. This message does not have a body text. Perhaps the saving of the text of Email messages was disabled',
    unable_edit_template: 'Unable to edit the template!<br> This template has a draft for moderation',
    invalid_distribution_status: 'Invalid distribution status',
    not_all_rules_passed: 'Not all rule identifiers were passed in the request',
    duplicate_template_name: 'Duplicate name',
    import_file_too_long: 'The file cannot be imported. There are too many entries in the imported file',
    system_setting_not_specified: 'The request could not be completed. System setting {name} not set.',
    no_partner_user_found: 'The user’s personal account with such email is not in the system',
    change_password_limit: 'The number of attempts to change the password within the specified time has been exceeded',
    invalid_import_file: 'Import is not possible.<br>The file is incorrect or the separator is incorrect.',
    regular_expression_not_allowed: 'To use regular expression elements in text, such as: "[", "]", "{", "}", "\\", "+", "*", "%w", "%d", "^", "$", "|"; should be choosed the condition: "Matches regular expression',
    public_private_key_not_valid: 'The public and private key pair is not valid',
    delete_operation_failed: 'Failed to perform the delete operation',
    file_used_in_templates: 'Object is used in templates',

    syntax_error: 'Internal server error.',
    unable_data: 'Unable to get data. Required parameters not set:',
    invalid_date_format: 'Invalid date format',
    invalid_date_interval: 'Unable to get data. Incorrect date interval',
    forbidden: 'Unable to get data. Access to the page is not allowed',
    transport_not_allowed: 'Невозможно получить данные. Транспорт не разрешён',
    unable_save_contact: 'It is impossible to save the contact. Contact with the same data already exists in this list.',
    unable_save_template: 'The template cannot be saved. Possible cascading send loop in template with channel id {templateID} {transport}',
    viber_custom_content_validation: "One of the fields 'Message', 'Image link', 'Button name', 'Button link', 'File' must be filled",
    viber_button_requires_link_or_file: "If the 'Button Name' field is filled in, then one of the fields 'Button Link' or 'File' must also be filled in"
  },

  dialog: {
    confirm: 'Save changes?',
    delete: 'Are you sure you want to delete the entry?',
    error: 'Error detected',
    warning: 'WARNING!',
    success: 'Operation completed successfully',
    export: 'Report successfully exported',
    error_export: 'An error occurred while exporting',
    resend: 'The message will be resent',
    not_selected_transport: 'You must select at least one transport',
    delete_all_default_category: '1. When assigning a category to a default category, all associated regular expressions for this transport will be deleted.<br>\
    2. If a default category is already set for this transport, this attribute will be removed from it, and in order for it to be applied to messages, it will be necessary to configure regular expressions.<br>\
    3. If the tariff/tariff zone did not have a default price, and the canceled default category was the only one for which billing was performed, then sending in this direction will not be possible until regular expressions are configured.<br><br>\
    Do you really want to continue?',
    delete_all_tarifzone: 'All associated regular expressions and rate zone settings will be removed',
    deletion_in_one_minute: "The record(s) will be deleted within 1 minute. Are you sure you want to proceed?"
  },

  pages: {
    Dashboard: 'Dashboard',

    sms: 'SMS',
    sms_templates: 'Templates',
    sms_templates_new: 'Create template',
    sms_templates_edit: 'Edit template',
    sms_detail: 'SMS detail statistics',
    sms_detail_info: 'Message Information',
    sms_group: 'SMS group statistics',
    sms_tarification_partners: "SMS clients routing and tariffication\n",
    sms_tarification_partners_new: "Create client's tariff zone",
    sms_tarification_partners_edit: 'Edit client\'s tariff zone',
    sms_tarification_partners_group: 'Tariffication group settings',
    sms_tarification_operators: "SMS service providers routing and tariffication",
    sms_tarification_operators_new: 'Create service provider\'s tariff zone',
    sms_tarification_operators_edit: 'Edit service provider\'s tariff zone',
    sms_tarification_operators_group: 'Tariffication group settings',
    sms_originator_rules: 'Change SMS originator',
    sms_originator_rules_new: 'Create rule for changing SMS originator',
    sms_originator_rules_edit: 'Edit rule for changing SMS originator',
    sms_filters: 'SMS text filters',
    sms_filters_new: 'Create SMS text filter',
    sms_filters_edit: 'Edit SMS text filter',
    sms_incoming_tariffs: 'Routing of incoming SMS',
    sms_incoming_tariffs_new: 'Routing of incoming SMS',
    sms_incoming_tariffs_edit: 'Routing of incoming SMS',
    sms_group_incoming: 'Incoming SMS group statistics',
    sms_detail_incoming: 'Incoming SMS detail statistics',
    sms_detail_incoming_info: 'Message information',
    originator_restrictions: 'Allowed originators',
    originator_restrictions_new: 'Create originator restriction rule',
    originator_restrictions_edit: 'Edit originator restriction rule',

    push: 'Push',
    push_detail: 'Push detail statistics',
    push_detail_info: 'Message information',
    push_group: 'Push group statistics',
    push_templates: 'Templates',
    push_templates_new: 'Create template',
    push_templates_edit: 'Edit template',
    attributes: 'Attributes',
    attributes_new: 'Create attribute',
    attributes_edit: 'Edit attribute',
    push_applications: 'Application management',
    push_applications_new: 'Create application',
    push_applications_edit: 'Edit application',
    push_subscribers: 'Subscriber management',
    push_subscribers_edit: 'Subscriber information',
    push_devices: 'Device management',
    push_devices_edit: 'Device information',
    push_groups_applications: 'Application groups',
    push_groups_applications_new: 'Create application groups',
    push_groups_applications_edit: 'Edit application groups',
    push_subscribers_count: 'Number of subscribers',
    push_history: 'Subscription history',
    push_client_tariff: 'Push clients tariffication',
    push_client_tariff_new: 'Create Push client tariffication',
    push_client_tariff_edit: 'Edit Push client tariffication',

    call: 'Calls',
    call_group_incoming: 'Incoming Calls group statistics',
    call_detail_incoming: 'Incoming Calls detail statistics',
    call_detail_incoming_info: 'Message information',
    call_detail: 'Call detail statistics',
    call_detail_info: 'Call Information',
    call_group: 'Call group statistics',
    call_originator_rules: 'Call originator rules',
    call_originator_rules_new: 'Create Call originator rule',
    call_originator_rules_edit: 'Edit Call originator rule',
    call_ivr_menus: 'IVR-menus',
    call_ivr_menus_new: 'Create IVR-menu',
    call_ivr_menus_edit: 'Edit IVR-menu',
    call_templates: 'Templates',
    call_templates_new: 'Create template',
    call_templates_edit: 'Edit template',
    call_tarification_operators: "Call service providers routing and tariffication",
    call_tarification_operators_new: 'Create service provider\'s tariff zone',
    call_tarification_operators_edit: 'Edit service provider\'s tariff zone',
    call_tarification_operators_group: 'Tariffication group settings',
    call_sound_library: 'Sound library',
    call_sound_library_new: 'Creating file',
    call_sound_library_view: 'View file',

    email: 'Email',
    email_detail: 'Email detail statistics',
    email_detail_info: 'Message information',
    email_events_detail_info: 'Event information',
    email_group: 'Email group statistics',
    email_group_events: 'Email events group statistics',
    email_templates: 'Templates',
    email_templates_new: 'Create template',
    email_templates_edit: 'Edit template',
    email_clients_tariff: 'Email clients tariffication',
    email_clients_tariff_new: 'Create Email clients tariffication',
    email_clients_tariff_edit: 'Edit Email clients tariffication',
    email_provider_tariff: 'Email service providers tariffication',
    email_provider_tariff_new: 'Create Email service providers tariffication',
    email_provider_tariff_edit: 'Edit Email service providers tariffication',

    viber: 'Viber',
    viber_detail: 'Viber detail statistics',
    viber_detail_info: 'Message information',
    viber_group: 'Viber group statistics',
    viber_templates: 'Templates',
    viber_templates_new: 'Create template',
    viber_templates_edit: 'Edit template',
    viber_client_tariff: 'Viber clients tariffication',
    viber_client_tariff_new: 'Create Viber clients tariffication',
    viber_client_tariff_edit: 'Edit Viber clients tariffication',
    viber_provider_tariff: 'Viber service providers tariffication',
    viber_provider_tariff_new: 'Create Viber service providers tariffication',
    viber_provider_tariff_edit: 'Edit Viber service providers tariffication',
    viber_incoming_tariffs: 'Routing of incoming messages',
    viber_incoming_tariffs_new: 'Routing of incoming messages',
    viber_incoming_tariffs_edit: 'Routing of incoming messages',
    viber_detail_incoming: 'Incoming Viber messages detail statistics',
    viber_detail_incoming_info: 'Message Information',
    viber_group_incoming: 'Incoming Viber messages group statistics',

    whatsapp: 'WhatsApp',
    whatsapp_detail: 'WhatsApp detail statistics',
    whatsapp_detail_info: 'Message information',
    whatsapp_group: 'WhatsApp group statistics',
    whatsapp_templates: 'Templates',
    whatsapp_templates_new: 'Create template',
    whatsapp_templates_edit: "Edit template",
    whatsapp_client_tariff: 'WhatsApp clients tariffication',
    whatsapp_client_tariff_new: 'Create WhatsApp clients tariffication',
    whatsapp_client_tariff_edit: 'Edit WhatsApp clients tariffication',
    whatsapp_incoming_tariffs: 'Routing of incoming messages',
    whatsapp_incoming_tariffs_new: 'Routing of incoming messages',
    whatsapp_incoming_tariffs_edit: 'Routing of incoming messages',
    whatsapp_provider_tariff: 'WhatsApp service providers tariffication',
    whatsapp_provider_tariff_new: 'Create WhatsApp service providers tariffication',
    whatsapp_provider_tariff_edit: 'Edit WhatsApp service providers tariffication',
    whatsapp_detail_incoming: 'Incoming WhatsApp messages detail statistics',
    whatsapp_detail_incoming_info: 'Message Information',
    whatsapp_group_incoming: 'Incoming WhatsApp messages group statistics',

    mail_notify: 'Mail Notify',
    mail_notify_templates: 'Templates',
    mail_notify_templates_new: 'Create template',
    mail_notify_templates_edit: "Edit template",
    mail_notify_management_templates: 'Operators templates Mail Notify',
    mail_notify_management_templates_new: 'Create Mail Notify template',
    mail_notify_management_templates_edit: 'Edit Mail Notify service template',
    mail_notify_detail: 'Mail Notify detail statistics',
    mail_notify_detail_info: 'Message Information',
    mail_notify_group: 'Mail Notify group statistics',
    mail_notify_client_tariff: 'Mail Notify clients tariffication',
    mail_notify_client_tariff_new: 'Create Mail Notify clients tariffication',
    mail_notify_client_tariff_edit: 'Edit Mail Notify clients tariffication',
    mail_notify_provider_tariff: 'Mail Notify service providers tariffication',
    mail_notify_provider_tariff_new: 'Create Mail Notify service providers tariffication',
    mail_notify_provider_tariff_edit: 'Edit Mail Notify service providers tariffication',
    mail_notify_management_services: 'Operators services Mail Notify',
    mail_notify_management_services_new: 'Create Mail Notify service',
    mail_notify_management_services_edit: 'Edit Mail Notify service',

    custom: 'Custom',
    custom_detail: 'Custom detail statistics',
    custom_detail_info: 'Message information',
    custom_group: 'Custom group statistics',
    custom_templates: 'Templates',
    custom_templates_new: 'Create template',
    custom_templates_edit: "Edit template",
    custom_client_tariff: 'Custom clients tariffication',
    custom_client_tariff_new: 'Create Custom clients tariffication',
    custom_client_tariff_edit: 'Edit Custom clients tariffication',
    custom_provider_tariff: 'Custom service providers tariffication',
    custom_provider_tariff_new: 'Create Custom service providers tariffication',
    custom_provider_tariff_edit: 'Edit Custom service providers tariffication',
    custom_detail_incoming: 'Detailed statistics of incoming Custom',
    custom_detail_incoming_info: 'Message Information',
    custom_group_incoming: 'Group statistics of incoming Custom',

    cdp: 'CDP',
    cdp_detail: 'CDP detail statistics',
    cdp_detail_info: 'Message information',
    cdp_group: 'Cdp group statistics',

    settings: 'Settings',
    service_providers:'Service providers',
    service_providers_new:'Create service provider',
    service_providers_edit:'Edit service provider',
    partners:'Clients',
    partners_new:'Create client',
    partners_edit:'Edit client',
    accounts:'Accounts',
    accounts_new:'Create account',
    accounts_edit:'Edit account',
    originators: 'Originators',
    originators_new:'Create originator',
    originators_edit:'Edit originator',
    system_settings: 'System settings',
    system_settings_new: 'Create system setting',
    system_settings_edit: 'Edit system setting',
    reports: 'Reports',
    message_types: 'Message types',
    message_types_new: 'Create message type',
    message_types_edit: 'Edit message type',
    message_categories: 'Message categories',
    message_categories_new: 'Create message category',
    message_categories_edit: 'Edit message category',
    message_categories_regexes:'Regular expression management',
    message_categories_regexes_new:'Creating a regular expression',
    message_categories_regexes_edit:'Editing a regular expression',
    duplicates: 'Duplicate rules',
    duplicates_new: 'Create Duplicate rule',
    duplicates_edit: 'Edit Duplicate rule',
    quantity_limits: 'Message quantity limits',
    quantity_limits_new: 'Create rules to limit the number of messages sent',
    quantity_limits_edit: 'Editing the rule for limiting the number of messages sent',
    provider_connections: 'Connections of service providers',
    partners_connections: 'Client Connections',
    partners_connections_new: 'Create client connection',
    partners_connections_edit: 'Edit client connection',
    smpp_connections: 'SMPP connections',
    smpp_connections_new: 'Create SMPP connection',
    smpp_connections_edit: 'Edit SMPP connection',
    additional_rules: 'Additional rules',
    additional_rules_new: 'Create new rule',
    additional_rules_edit: 'Edit rule',
    black_lists: 'Black lists',
    black_lists_new: 'Create black list',
    black_lists_edit: 'Edit black list',
    black_list_contacts: 'Black list contacts',
    black_list_contacts_new: 'Create black list contact',
    black_list_contacts_edit: 'Edit black list contact',
    black_list_generals: 'General black lists',
    black_list_generals_recipients: 'General black list',
    black_list_generals_recipients_new: 'Creating a contact to the general black lists',
    black_list_generals_recipients_edit: 'Editing a contact in the general black lists',
    white_lists: 'White list',
    white_lists_new: 'Creating a contact to the white list',
    white_lists_edit: 'Editing a contact in the white list',
    proxy_settings: 'Proxy settings',
    proxy_settings_new: 'Create proxy setting',
    proxy_settings_edit: 'Editing proxy setting',
    priority_rules: 'Change priority',
    priority_rules_new: 'Create priority rule',
    priority_rules_edit: 'Edit priority rule',
    template_params: 'Template params',
    template_params_new: 'Create template params',
    template_params_edit: 'Edit template params',
    pools: 'Number pools',
    pools_new: 'Creating numbers pool',
    pools_edit: 'Edit numbers pool',
    pool_numbers: 'Numbers in pool',
    pool_numbers_edit: 'Edit number in pool',
    pool_numbers_new: 'Creating number in pool',

    user_management: 'User management',
    partner_users: 'Client accounts',
    partner_users_new: 'Create client account',
    partner_users_edit: 'Edit client account',
    callcenter_users: 'Call center users',
    callcenter_users_new: 'Create call center user',
    callcenter_users_edit: 'Edit call center user',
    action_users: 'User actions',
    action_users_info: 'User action details',
    user_roles: 'Roles',
    user_roles_new: 'Create role',
    user_roles_edit: 'Edit role',
    partner_user_roles: 'Client accounts roles',
    partner_user_roles_new: 'Creating a user account role',
    partner_user_roles_edit: 'Editing the role of users of the personal account',
    system_users: 'System Users',
    system_users_new: 'Create system user',
    system_users_edit: 'Edit system user',
    system_actions: 'User actions logging settings',
    system_actions_edit: 'Edit logging settings',

    templates_moderation: 'Templates moderation',
    templates_moderation_edit: 'Template moderation',
    distributions_moderation: 'Distributions moderation',
    distributions_moderation_edit: 'Distribution moderation',

    finance: 'Financial management',
    balances: 'Balance history',
    overdrafts: 'Balance management',

    top_up_balance: 'Top up balance',
    overdraft_settings: 'Shutdown threshold settings',

    incoming_tariffs: 'Routing of incoming messages',
    incoming_tariffs_new: 'Routing of incoming messages',
    incoming_tariffs_edit: 'Routing of incoming messages',
  },

  lang: {
    ru: 'Русский',
    en: 'English',
  },

  variable: {
    number: 'Number',
    name: 'Name',
    surname: 'Surname',
    patronymic: 'Patronymic',
    field_1: 'Field 1',
    field_2: 'Field 2',
    field_3: 'Field 3',
    field_4: 'Field 4',
    field_5: 'Field 5',
    field_6: 'Field 6',
  },

  week_days: {
    MON: 'Monday',
    TUE: 'Tuesday',
    WED: 'Wednesday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday',
    SUN: 'Sunday',
  },

  user_management: {
    system_actions: {
      user_action: 'User actions',
      fields: {
        create: 'Creating an entity',
        update: 'Updating an entity',
        view: 'Page view',
        delete: 'Deleting an entity',
        authorization: 'User authorization',
        permission: 'Changing access rights',
        topups: 'Replenishment of the client\'s balance',
      }
    }
  },

  charging: {
    sending: 'For sending',
    delivery: 'For delivery',
    sec: 'For second',
    min: 'For minute',
  },

  routing: {
    name: 'Routing',
    msisdn: 'By MSISDN prefix',
    'mcc/mnc': 'By MCC/MNC'
  },

  is_allowed: {
    name: 'Sending allowed',
    all: 'Through  all service providers',
    allowed: 'Through allowed service providers'
  },

  values: {
    priority: {
      2: 'Low',
      4: 'Normal',
      6: 'High',
      8: 'Realtime',
    },
    active: {
      all: 'All',
      active: 'Active',
      inactive: 'Not active',
      yes: 'Yes',
      no: 'No',
      1: 'Active',
      0: 'Not active',
    },
    message_status: {
      Failed: 'Failed',
      Rejected: 'Rejected',
      NotDelivered: 'Not Delivered',
      Delivered: 'Delivered',
      Deferred: 'Deferred',
      Expired: 'Expired',
      Transmitted: 'Transmitted',
      NotAnswered:'Not Answered',
      Buffered:'Buffered',

      Read: 'Read',
      Error: 'Error',
      Processed: 'Processed',
      Finished: 'Finished',
      New: 'New'
    },
    sender_status: {
      ACCEPTED: 'Accepted',
      UNDER_CONSIDERATION: 'Under consideration',
      DENIED: 'Denied',
    },
    report_status: {
      NEW: 'New',
      IN_PROCESS: 'In process',
      FINISHED: 'Finished',
      FAILED: 'Failed',
    },
    template_status: {
      ForModeration: 'Awaiting moderation',
      OnModeration: 'On moderation',
    },
    provider_connection_status: {
      1: 'Connected',
      0: 'Not Connected',
    },
    date: {
      min: '5 min',
      min_15: '15 min',
      hour: '1 hour',
      today: 'Today',
      yesterday: 'Yesterday',
      week: 'Week',
      month: 'Month',
    },
    group_by: {
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      partner: 'Client',
      service_provider: 'Service provider',
      originator: 'Originator',
      recipient_operator: 'Recipient operator',
      operator: 'Operator',
      template_id: 'Template ID',
      bulk_id: 'Bulk ID',
      service_number: 'Number',
      recipient: 'Service number',
      originator_operator: 'Operator',
      broker_account_login:'Account',
      application: 'Application',
      platform: 'Platform',
      os: 'Operating system',
      message_category:'Message category',
      message_type:'Message type',
      mn_service_name: 'Mail Notify Service',
      mn_tmpl: 'Mail Notify Template',
      receiver: 'Recipient',
      event_type: 'Event type',
      ext_event_profile_id: 'Event profile ID',
      ext_campaign_id: 'External campaign ID',
      connection_type: 'Connection type',
      partner_user_login: 'Client login',
      server_info: 'Server info'
    },
    devices_list:{
      ALL: 'All',
      ONLY_LAST: 'Only last',
    },
    delimiter_list: {
      comma: 'Comma',
      semicolon: 'Semicolon',
      space: 'Space',
    },
    mn_status: {
      0: 'Moderation',
      1: 'Confirmed',
    },
    attribute_owner_list: {
      client: 'Client',
      device: 'Device',
    },
    actions_status: {
      0: 'Not allowed',
      1: 'Allowed',
    },
    applications: {
      all: 'All',
      last_created: 'Last created',
      by_priority: 'By priority',
      last_subscription: 'Last Subscription',
    },
    position: {
      preproc: "Preprocessing",
      preroute: "Pre-routing"
    },
    specialUnsubscribeRuleList: {
      'do-not-unsubscribe': 'Do not unsubscribe',
      all: 'Unsubscribe from all emails',
      template: 'Unsubscribe from template',
      'message-type': 'Unsubscribe from message type',
    },
    unsubscribeRuleList: {
      'all': 'Unsubscribe from all emails',
      'template': 'Unsubscribe from template',
      'message-type': 'Unsubscribe from message type',
    },
    subscribeRuleList: {
      'all': 'Subscribe to all emails',
      'template': 'Subscribe to template',
      'message-type': 'Subscribe to message type',
    },
    event_type_list: {
      'opening': 'Message opening',
      'unsubscribing': 'Unsubscribing',
      'subscribing': 'Subscribing',
      'following_link': 'Following link',
    },
    is_public: {
      root: 'Publicly available',
      1: 'On',
      0: 'Off',
    },
    publicity: {
      1: 'Public',
      0: 'Non-public'
    },
    call_types: {
      ivrmenu: 'IVR-menu',
      text: 'TTS',
      file: 'Sound file'
    }
  },

  widget: {
    options: {
      update: 'Update frequency',
      interval: 'Time interval',
      chanel: 'Sending channel',
      group_by: 'Group by',
      direction: 'Sending direction',
      track: 'Track',
      service_provider: 'Service provider',
      statuses: 'Statuses',
      min: 'min',
      no: 'No',
      hour: 'last hour',
      today: 'today',
      yesterday: 'yesterday',
      more: 'more',
      from: 'from',
      to: 'to',
    },
    channel: {
      SMS: 'SMS',
      Push: 'Push-notifications',
      Viber: 'Viber-messages',
      Email: 'Email',
      Call: 'Call',
      WhatsApp: 'WhatsApp-messages',
    },
    statuses: {
      finished: 'Finished',
      not_answered: 'Not answered',
      buffered: 'Buffered',
      error: 'Error',
      read: 'Read',
      transmitted: 'Transmitted',
      delivered: 'Delivered',
      not_delivered: 'Not delivered',
      expired: 'Expired',
      failed: 'Failed',
      rejected: 'Rejected',
      deferred: 'Deferred',
    },
    WCSActivity: {
      name: 'WCS Activity',
      title: 'WCS Activity',
      status: {
        active: 'All instances are active',
        inactive: 'Instances are not active',
      },
    },
    SMPPActivity: {
      name: 'SMPP-connections Activity',
      title: 'SMPP-connections Activity',
      partner: 'Incoming',
      service_provider:'Outgoing',
      no_data: 'No connections',
      status: {
        active: 'All incoming (outgoing) active',
        inactive: 'There is no connection activity',
      },
      options: {
        tracks: {
          all: 'all connections',
          partner: 'incoming only (SMPP-accounts of partners)',
          service_provider: 'outgoing only (SMPP-connections of service providers)',
        }
      },
    },
    ShippingSummary: {
      name: 'Summary of the sending for the period',
      title: 'from 14:00 to 15:00 sent',
    },
    MessageStatuses: {
      name: 'Message statuses for a period of time',
      title: 'Message statuses',
    },
    MessagesByGroup: {
      name: 'Splitting messages into groups',
      title: 'Messages by service providers',
      options: {
        group_by: {
          partner: 'by clients',
          service_provider: 'by service providers',
          application: 'by application',
          os: 'by operating system',
        }
      }
    },
    TrafficSending: {
      name: 'Traffic sending schedule',
      title: 'The schedule of sending messages from 01.06 to 02.06',
    },
    TrafficProviders: {
      name: 'Comparison of traffic delivery by service provider',
      title: 'Comparison of the percentage of delivery',
    },
    SendingProviders: {
      name: 'Shipping schedule by service provider',
      title: 'Shipping schedule',
    },
    ErrorsProviders: {
      name: 'Distribution of errors by suppliers',
      title: 'Distribution of {chanel} errors by suppliers',
    },
  },

  sms_filter: {
    eq: 'Equal',
    noteq: 'Not equal',
    in: 'Include',
    notin: 'Not include',
    is_regex: 'Satisfies regular expression'
  },

  restrictions: {
    alpha: 'Alphabetic only',
    numeric: 'Numeric only',
    allowed: 'Predefined',
  },

  dates: {
    create_date: 'Create date',
    date: 'Date',
    date_from: 'Date from',
    date_to: 'Date to',
    defer_date: 'Defer date',
    delivery_date: 'Delivery date',
    deliver_date_from: 'Deliver date from',
    deliver_date_to: 'Deliver date to',
    edit_date: 'Edit date',
    end_date: 'End date',
    end_date_from: 'Deliver date from',
    end_date_to: 'Deliver date to',
    event_date: 'Event Date',
    read_date: 'Read date',
    sent_date: 'Sent date',
    sent_date_from: 'Sent date from',
    sent_date_to: 'Sent date to',
    start_date: 'Start date',
    start_date_from: 'Create date from',
    start_date_to: 'Create date to',
  },

  statuses: {
    buffered: 'Buffered',
    deferred: 'Deferred',
    delivered: 'Delivered',
    duration: 'Duration',
    error: 'Error',
    expired: 'Expired',
    failed: 'Failed',
    finished: 'Finished',
    not_answered: 'Not answered',
    not_delivered: 'Not delivered',
    processed: 'Processed',
    read: 'Read',
    rejected: 'Rejected',
    statuses: 'Statuses',
    transmitted: 'Transmitted',
  },

  descriptions: {
    deferred: 'Messages will be sent later',
    delivered: 'Messages were delivered to the subscriber',
    expired: "Messages have been sent to the service provider, their lifetime expired in the provider's queue",
    failed: 'An error occurred while trying to send a message',
    not_delivered: 'Messages were not delivered to the subscriber. Final status',
    read: 'Messages have been read',
    rejected: 'Messages were rejected by the platform',
    total: 'Total number of messages',
    transmitted: 'Messages have been sent to the service provider, but the delivery status has not yet been received',
    partner_price: 'Client price',
    provider_price: 'Service provider price',
  },

  helps: {
    template_activity_html: "Start and end dates of the template.<ul>" +
        "<li>If the start date is not filled in, then the template will take effect immediately. If filled in, the template will take effect from the specified date.</li>" +
        "<li>If the end date is not filled in, then the validity period of the template is not limited. If it is filled in, then the template will cease to be valid on the specified date.</li></ul>",
    template_timeout_html: "<ul><li>Some text for template timeout help</li></ul>",
    tariff_zones_group_settings: 'Please set up a group of tariff zones',
    tariff_zones_create: 'Create a new tariff zone',
    regex_condition: 'The condition used for check the entered text, the following options are supported:\n' +
        'Equal - to check the message for full compliance with the entered text in the "Text" field;\n' +
        'Not equal - to check if the message does not match the entered text in the "Text" field;\n' +
        'Include - to check the message for the presence of the substring entered in the "Text" field;\n' +
        'Not include - to check the message for the absence of a substring entered in the "Text" field;\n' +
        'Matches regular expression - to check if the message matches the regular expression entered in the "Text" field.'
  },

  symbols: {
    1: 'symbol',
    2: 'symbols',
    3: 'symbols',
  },

  minutes: {
    1: 'minute',
    2: 'minutes',
    3: 'minutes',
  },

  days: {
    1: 'day',
    2: 'days',
    3: 'days',
  }
};

export default messages;
